import React, { useState, useEffect } from 'react';
// (Seus imports do Chakra UI)
import { ModalFooter, Flex, Box, Text, Button } from '@chakra-ui/react'; 

interface PixTimerFooterProps {
  isOpen: boolean;
  dataExpiracao: string | undefined; 
}

export const PixTimerFooter: React.FC<PixTimerFooterProps> = ({ isOpen, dataExpiracao }) => {
  const [tempoRestante, setTempoRestante] = useState<string>("");
  const [expirado, setExpirado] = useState<boolean>(false);

  useEffect(() => {

    let intervalo: NodeJS.Timeout | undefined;

    if (!isOpen || !dataExpiracao) {
      setExpirado(false);
      setTempoRestante("");
      return;
    }

    const dataExpiracaoISO = dataExpiracao.replace(" ", "T") + "Z";
    const dataExpiracaoDate = new Date(dataExpiracaoISO);

    // --- FUNÇÃO CORRIGIDA ---
    const calcularTempo = () => {
      const agora = new Date();
      const diferencaMs = dataExpiracaoDate.getTime() - agora.getTime();

      // Se o tempo acabou
      if (diferencaMs <= 0) {
        setExpirado(true);
        setTempoRestante("00:00:00"); // Alterado para formato consistente

        if (intervalo) clearInterval(intervalo); 
        return;
      }

      // --- LÓGICA DE CÁLCULO ATUALIZADA ---
      
      // 1. Calcula o total de horas, minutos e segundos
      const totalSegundos = Math.floor(diferencaMs / 1000);
      const totalMinutos = Math.floor(totalSegundos / 60);
      const totalHoras = Math.floor(totalMinutos / 60);
      const totalDias = Math.floor(totalHoras / 24);

      // 2. Pega o "resto" para exibição (horas do dia, minutos da hora, segundos do minuto)
      const segundos = totalSegundos % 60;
      const minutos = totalMinutos % 60;
      const horas = totalHoras % 24;

      // 3. Formata para dois dígitos
      const segFormatado = String(segundos).padStart(2, '0');
      const minFormatado = String(minutos).padStart(2, '0');
      const horasFormatado = String(horas).padStart(2, '0');

      // 4. Monta a string de exibição
      let tempoString = `${horasFormatado}:${minFormatado}:${segFormatado}`;
      
      // Se tiver mais de 1 dia, adiciona o "d" (ex: "1d 05:30:15")
      if (totalDias > 0) {
        tempoString = `${totalDias}d ${tempoString}`;
      }
      
      setTempoRestante(tempoString);
    };
    // --- FIM DA CORREÇÃO ---

    calcularTempo(); 

    intervalo = setInterval(calcularTempo, 1000);

    return () => {
      if (intervalo) clearInterval(intervalo);
    };

  }, [isOpen, dataExpiracao]);
  
  // (O seu JSX de retorno continua o mesmo)
  return (
    <ModalFooter>
      <Flex justifyContent="space-between" alignItems="center" w="100%">
        
        {expirado ? (
          <Box textAlign="left">
            <Text color="red.500" fontWeight="bold" fontSize="lg">
              PIX Vencido!
            </Text>
            <Text fontSize="sm" color="gray.600">
              Por favor, gere um novo pedido.
            </Text>
          </Box>
        ) : (
          <Box textAlign="left">
            <Text fontSize="sm" color="gray.600">Tempo restante:</Text>
            <Text fontSize="3xl" fontWeight="bold" color="red.500" lineHeight="1.1">
              {tempoRestante}
            </Text>
          </Box>
        )}

        <Button isLoading loadingText={"Aguardando confirmação"}></Button>
      </Flex>
    </ModalFooter>
  );
};